
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { Prop } from 'vue-property-decorator';
    import HistoryEvent from "@/features/applications/components/history/HistoryEvent.vue";
    import { ApplicationHistoryEventModel, RequirementFulfillmentViewModel, RequirementViewModel} from "@/api-client";
    import CreateUUID from "@/guid";
    import ApplicationAdditionalInfoInput from "@/features/applications/components/ApplicationAdditionalInfoInput.vue"

    class HistoryEventGroup {
        constructor(public events: ApplicationHistoryEventModel[],
                    public readonly isImportant: boolean,
                    public readonly isCollapsable: boolean,
                    public isCollapsed: boolean) {
        }
        id = CreateUUID();
    }

    @Component({
        components: {
            HistoryEvent,
            ApplicationAdditionalInfoInput
        }
    })
    export default class ApplicationHistory extends Vue {
        showHistory= true;

        @Prop()
        isOfficial!: boolean;

        @Prop({ required: true })
        applicationId!: string;

        @Prop({ required: true})
        historyEvents!: ApplicationHistoryEventModel[];

        @Prop({ required: true})
        requirementFulfillments!: RequirementFulfillmentViewModel[];

        @Prop({ required: true})
        isApplicationOverview!: boolean;

        historyEventGroups: HistoryEventGroup[] = [];

        created() {
            this.$watch(() => this.historyEvents, () => {
                this.historyEventGroups = this.splitEventsIntoGroups(this.historyEvents);
            }, {immediate: true});
        }

        // TODO: This logic is kind of duplicated in the back-end when creating history "parts":
        splitEventsIntoGroups(historyEvents: ApplicationHistoryEventModel[]){
            const historyEventGroups: HistoryEventGroup[] = [];
            for(const event of historyEvents){
                if (event.key){
                    historyEventGroups.push(new HistoryEventGroup([], true, false, false));
                }
                else if (!historyEventGroups.some(g => !g.isImportant && !g.isCollapsable)) {
                    historyEventGroups.push(new HistoryEventGroup([], false, false, false));
                }
                else if (historyEventGroups.last().isImportant) {
                    historyEventGroups.push(new HistoryEventGroup([], false, true, true));
                }
                historyEventGroups.last().events.push(event);
            }
            return historyEventGroups;
        }

        findRequirement(event: ApplicationHistoryEventModel): RequirementViewModel | null {
            if (!event.requirementId)
                return null;

            const fulfillment = this.requirementFulfillments.find(x => x.requirementId == event.requirementId);
            return fulfillment ? fulfillment.requirement : null;
        }
    }

